import { createFileRoute } from '@tanstack/react-router';

import { FieldsMap } from '@fields/feature';

export const Route = createFileRoute('/_app/map')({
  component: FieldsMap,
  errorComponent: FieldsMap.Error,
});
